/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { ResponseWithErrorGeneric } from '../../shared/response-with-error-generic';
import { GetCustomerInvoiceRecipientsJson } from './get-customer-invoice-recipients-json';
import { DefaultGetResult } from '../../results/default-get-result.enum';
import { IResponseWithErrorGeneric } from '../../shared/iresponse-with-error-generic.interface';
import { InvoiceRecipientDto } from '../models/invoice-recipient-dto';

//<custom-head>
import { HttpResponse } from '@angular/common/http';
import { orderBy } from 'lodash-es';
//</custom-head>

export class GetCustomerInvoiceRecipientsResponse extends ResponseWithErrorGeneric<GetCustomerInvoiceRecipientsJson, DefaultGetResult> implements IResponseWithErrorGeneric<DefaultGetResult> {
  public invoiceRecipients: InvoiceRecipientDto[];

  //<custom-body>
  constructor(response: HttpResponse<GetCustomerInvoiceRecipientsResponse>) {
    super(response, DefaultGetResult.Error);
    if (this.result !== DefaultGetResult.Success) {
      return;
    }

    this.invoiceRecipients = orderBy(this.body.invoiceRecipients, c => c.name);
  }
  //</custom-body>
}
